import React, { PropsWithChildren } from 'react'

import { useAxiosInterceptors, useTokenLogin } from '@hooks'

import LoadingSpinner from '../LoadingSpinner'

const LoginWithToken: React.FC<PropsWithChildren> = ({ children }) => {
  const { isLoginLoading } = useTokenLogin()

  useAxiosInterceptors()

  return isLoginLoading ? <LoadingSpinner /> : children
}

export { LoginWithToken }
